import { TableHead, TableRow } from '@mui/material';

import { StyledHeaderBoxTableCell, StyledHeaderTableCell } from '~/shared';
import SortIcon from '~/shared/icons/SortIcon';
import { MetricSortColumn } from '~/types';

type MetricTableHeadProps = {
  firstColumnLabel: string;
  getSortOrder: (column: MetricSortColumn) => 'asc' | 'desc' | false;
  toggleSort: (column: MetricSortColumn) => void;
};

export function MetricTableHead({
  firstColumnLabel,
  getSortOrder,
  toggleSort,
}: MetricTableHeadProps) {
  return (
    <TableHead>
      <TableRow>
        <StyledHeaderTableCell sx={{ minWidth: 240 }}>
          {firstColumnLabel}
        </StyledHeaderTableCell>
        <StyledHeaderTableCell align="center" sx={{ minWidth: 120 }}>
          <StyledHeaderBoxTableCell>
            Impressões
            <SortIcon
              sortOrder={getSortOrder('impressions')}
              onClick={() => toggleSort('impressions')}
            />
          </StyledHeaderBoxTableCell>
        </StyledHeaderTableCell>
        <StyledHeaderTableCell align="center" sx={{ minWidth: 100 }}>
          <StyledHeaderBoxTableCell>
            Cliques
            <SortIcon
              sortOrder={getSortOrder('clicks')}
              onClick={() => toggleSort('clicks')}
            />
          </StyledHeaderBoxTableCell>
        </StyledHeaderTableCell>
        <StyledHeaderTableCell align="center" sx={{ minWidth: 110 }}>
          <StyledHeaderBoxTableCell>
            CTR
            <SortIcon
              sortOrder={getSortOrder('ctr')}
              onClick={() => toggleSort('ctr')}
            />
          </StyledHeaderBoxTableCell>
        </StyledHeaderTableCell>
        <StyledHeaderTableCell align="center" sx={{ minWidth: 130 }}>
          Valor de Venda
        </StyledHeaderTableCell>
        <StyledHeaderTableCell align="center" sx={{ minWidth: 130 }}>
          <StyledHeaderBoxTableCell>
            GMV
            <SortIcon
              sortOrder={getSortOrder('gmv')}
              onClick={() => toggleSort('gmv')}
            />
          </StyledHeaderBoxTableCell>
        </StyledHeaderTableCell>
      </TableRow>
    </TableHead>
  );
}
